// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"5c27ecf5","488":"bfa79a89","595":"e5f7b7d4","703":"389bf0ef","762":"5d6a7bc8","943":"092f1a79"}[chunkId] + ".chunk.js";
};